module.exports = __webpack_public_path__ + "static/media/excel-logo.983c546b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/excel-logo.png
// module id = 500
// module chunks = 0